"use client";

import { Input } from "@/components/ui";
import { NEWS_PORTAL_PATH } from "@/lib/constants";
import { SearchIcon } from "lucide-react";

const SearchCard = () => (
	<form action={NEWS_PORTAL_PATH}>
		<div className="flex items-center justify-center gap-2 p-4">
			<div className="w-full">
				<Input
					type="text"
					placeholder="Search..."
					name="s"
					classNames={{
						label: "m-0",
						input: "px-4 py-2 border rounded-md outline-none",
					}}
				/>
			</div>

			<button className="flex items-center rounded bg-brand-primary p-2 text-white">
				<SearchIcon />
			</button>
		</div>
	</form>
);

export default SearchCard;
